import { createSelector } from '@reduxjs/toolkit';
import { ABTUnknownFlags } from '@yandex-int/abt/build/types';
import { RootState } from '../store';

const selectState = (state: RootState): RootState['experiments'] => state.experiments;

export const selectFlags = createSelector(
    [(state: RootState) => selectState(state).flags],
    (flags): Partial<ABTUnknownFlags> | undefined => flags,
);
